import React from 'react'
import {Translate} from "react-redux-i18n";
import {Alert, Form} from "react-bootstrap";
const I18n = require('react-redux-i18n').I18n;


export default class DisplayStatus extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            username: '',
            otp: '',
            usernameError: '',
            otpError: ''
        }
    }


    componentDidMount() {
        this.setState({
            username: this.props.username,
            otp: this.props.otp,
            usernameError: this.props.usernameError,
            otpError: this.props.otpError
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.username !== this.props.username) {
            this.setState({ username: this.props.username });
        }

        if (prevProps.otp !== this.props.otp) {
            this.setState({ otp: this.props.otp});
        }

        if (prevProps.usernameError !== this.props.usernameError) {
            this.setState({ usernameError: this.props.usernameError });
        }

        if (prevProps.otpError !== this.props.otpError) {
            this.setState({ otpError: this.props.otpError});
        }
    }


    render() {
            return (
                <React.Fragment>
                    <Form.Group controlId="username">
                        <Form.Label>
                            <Translate value="login.username.title"/>
                        </Form.Label>
                        <Form.Control type="text"
                                      placeholder={I18n.t("login.username.placeholder")}
                                      onChange={this.props.handleChange}
                                      value={this.state.username} />
                        {this.state.usernameError !== '' ?
                            <Alert variant={'danger'}>
                                {this.state.usernameError}
                            </Alert> : null}
                    </Form.Group>
                    <Form.Group controlId="otp">
                        <Form.Label>
                            <Translate value="login.otp.title"/>
                        </Form.Label>
                        <Form.Control type="password"
                                      placeholder={I18n.t("login.otp.placeholder")}
                                      onChange={this.props.handleChange}
                                      value={this.state.otp}
                        />
                        {this.state.otpError !== '' ?
                            <Alert variant={'danger'}>
                                {this.state.otpError}
                            </Alert> : null}
                    </Form.Group>
                </React.Fragment>
            )

    }
}


